"use strict";
/**
 * API helper functions for Role endpoints
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleApi = void 0;
const apiClient_1 = require("./apiClient");
exports.roleApi = {
    /**
     * Fetch all roles
     */
    getAll() {
        return apiClient_1.apiClient.get('/roles');
    },
};
